import _ from "lodash";
import {POD_KEY_PREFIX, PRODUCT_DETAIL_KEY} from "../constants/pod.constant";
import {getNextItemKey} from "../../common/utils/item-key-util";

export {
    prepareUploadedProductList,
    prepareUploadedProductListWithFieldMapping,
    prepareProductTypeAndCategories,
    prepareProductColors,
};

const prepareUploadedProductList = (uploadedProductsList) => {
    const productDataList = [];
    const headers = uploadedProductsList[0];

    _.forEach(uploadedProductsList, (singleRow, index) => {
        // @ts-ignore
        if (0 !== index && !_.isEmpty(_.compact(singleRow))) {
            productDataList.push(prepareUploadedProductDataRow(singleRow, headers));
        }
    });

    return productDataList;
}

const prepareUploadedProductDataRow = (singleRow, headers) => {
    const rowData: any = {};

    _.forEach(singleRow, (data, index) => {
        rowData[headers[index]] = data;
    });

    return rowData;
}

const prepareUploadedProductListWithFieldMapping = (uploadedProductsList, uploadedProductFields, podDetail) => {
    const productDataList = [];
    const headersFieldMap = _.keyBy(uploadedProductFields, 'label');

    _.forEach(uploadedProductsList, (singleRow, index) => {
        if (!_.isEmpty(singleRow)) {
            productDataList.push(prepareUploadedProductDataRowWithFieldMapping(singleRow, headersFieldMap, podDetail));
        }
    });

    return productDataList;
}

const prepareUploadedProductDataRowWithFieldMapping = (singleRow, headersFieldMap, podDetail) => {
    const rowData: any = {};

    _.forEach(singleRow, (value, label) => {
        if (headersFieldMap.hasOwnProperty(label)) {
            rowData[headersFieldMap[label].attribute] = value;
        }
    });

    rowData.market = podDetail.market;
    rowData.podId = podDetail.id;

    extractParentProduct(rowData)

    return rowData;
}

const prepareProductTypeAndCategories = (processedProductsList, podDetail) => {
    const productTypes = [];
    const latestParentProducts = [];
    const allProductDetail = {colors: []};

    const productTypesMap = _.groupBy(processedProductsList, PRODUCT_DETAIL_KEY.PRODUCT_TYPE);

    _.forEach(productTypesMap, (productList, productTypeName) => {
        if (productList && !_.isEmpty(productTypeName) && productTypeName !== 'undefined') {
            const productType: any = {name: productTypeName, total: productList.length};
            prepareCategories(productList, productType, latestParentProducts, allProductDetail);

            productTypes.push(productType);
        }
    });

    // const allColors = _.compact(_.uniq(allProductDetail.colors));
    const allColors = _.map(_.compact(_.uniq(allProductDetail.colors)), colorName => {
        return {
            name: colorName,
            isSingle: colorName.indexOf('/') === -1
        }
    });

    prepareProductColors(allColors, podDetail);

    return {
        productTypes: _.orderBy(productTypes, 'name'),
        latestParentProducts: latestParentProducts,
        allColors: _.orderBy(allColors, 'name'),
    };
}

const prepareProductColors = (allColors, podDetail) => {
    const existingColorsMap = _.keyBy(podDetail.colors, 'name');
    let existingColor;

    _.forEach(allColors, (color, index) => {
        existingColor = existingColorsMap[color.name];

        if (existingColor) {
            color.code = existingColor.code ? existingColor.code : '';
        }
    });
}

const prepareCategories = (productList, productType, latestParentProducts, allProductDetail) => {
    const categoriesMap = _.groupBy(productList, PRODUCT_DETAIL_KEY.CATEGORY);
    const categories = [];

    _.forEach(categoriesMap, (productList, categoryName) => {
        const category: any = {name: categoryName, total: productList.length};
        prepareColors(productList, category);
        prepareSizes(productList, category);
        prepareParentProducts(productList, category, productType, latestParentProducts);

        categories.push(category);
        allProductDetail.colors = _.concat(allProductDetail.colors, _.map(category.colors, 'name'));
    });

    productType.categories = _.orderBy(categories, 'name');
}

const prepareColors = (productList, parent) => {
    const colorsMap = _.groupBy(productList, PRODUCT_DETAIL_KEY.COLOR);
    const colors = [];

    _.forEach(colorsMap, (productList, colorName) => {
        if (!_.isEmpty(colorName)) {
            const color: any = {name: colorName, total: productList.length};
            colors.push(color);
        }
    });

    parent.colors = _.orderBy(colors, 'name');
    parent.totalColors = colors.length;
}

const prepareSizes = (productList, parent) => {
    const sizesMap = _.groupBy(productList, PRODUCT_DETAIL_KEY.SIZE);
    const sizes = [];

    _.forEach(sizesMap, (productList, sizeName) => {
        if (!_.isEmpty(sizeName)) {
            const size: any = {name: sizeName, total: productList.length};
            sizes.push(size);
        }
    });

    parent.sizes = _.orderBy(sizes, 'name');
    parent.totalSizes = sizes.length;
}

const prepareParentProducts = (productList, category, productType, latestParentProducts) => {
    const parentProductsMap = _.groupBy(productList, PRODUCT_DETAIL_KEY.PARENT);
    const parentProducts = [];
    let parentKey = '';

    _.forEach(parentProductsMap, (productList, parentName) => {
        if (!_.isEmpty(parentName)) {
            const parent: any = {name: parentName, total: productList.length};
            prepareColors(productList, parent);
            prepareSizes(productList, parent);

            parentProducts.push(parent);

            parentKey = productType.name + '|' + category.name + '|' + parentName;
            latestParentProducts.push({
                ...parent,
                category: category.name,
                productType: productType.name,
                market: productList[0].market,
                podId: productList[0].podId,
                key: parentKey,
            })
        }
    });

    category.parentProducts = _.orderBy(parentProducts, 'name');
    category.totalParentProducts = parentProducts.length;
}

const extractParentProduct = (product) => {
    let variantSuffix = '';
    let sizeColorSuffix = '';
    let sizeOrColorSuffix = '';
    let colorOrSizeSuffix = '';
    let colorOrSizeNoBracketSuffix = '';
    let sizeSuffix = '';
    let sizeNoBracketSuffix = '';
    let colorSuffix = '';
    const productName = product?.name || '';

    if (!_.isEmpty(product.size) && !_.isEmpty(product.color)) {
        sizeColorSuffix = '(' + product.size + ', ' + product.color + ')';
        sizeOrColorSuffix = '(' + product.size + '/' + product.color + ')';
        colorOrSizeSuffix = '(' + product.color + ' / ' + product.size + ')';
        colorOrSizeNoBracketSuffix = product.color + ' ' + product.size;
    }

    if (!_.isEmpty(product.size)) {
        sizeSuffix = '(' + product.size + ')';
        sizeNoBracketSuffix = product.size;
    }

    if (!_.isEmpty(product.color)) {
        colorSuffix = '(' + product.color + ')';
    }

    if (sizeColorSuffix && productName.indexOf(sizeColorSuffix) !== -1) {
        variantSuffix = sizeColorSuffix;
    } else if (sizeOrColorSuffix && productName.indexOf(sizeOrColorSuffix) !== -1) {
        variantSuffix = sizeOrColorSuffix;
    } else if (colorOrSizeSuffix && productName.indexOf(colorOrSizeSuffix) !== -1) {
        variantSuffix = colorOrSizeSuffix;
    } else if (colorOrSizeNoBracketSuffix && productName.indexOf(colorOrSizeNoBracketSuffix) !== -1) {
        variantSuffix = colorOrSizeNoBracketSuffix;
    } else if (sizeSuffix && productName.indexOf(sizeSuffix) !== -1) {
        variantSuffix = sizeSuffix;
    } else if (sizeNoBracketSuffix && productName.indexOf(sizeNoBracketSuffix) !== -1) {
        variantSuffix = sizeNoBracketSuffix;
    } else if (colorSuffix && productName.indexOf(colorSuffix) !== -1) {
        variantSuffix = colorSuffix;
    }

    product.parent = _.trim(_.replace(productName, variantSuffix, ''));
    product.variantSuffix = variantSuffix;
}
